var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQtTime = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M140.2 31.755c59.751 0 108.163 48.411 108.163 108.162 0 59.75-48.412 108.162-108.162 108.162S32.039 199.668 32.039 139.917c0-59.75 48.41-108.162 108.162-108.162m6.979 38.38h-13.957a6.98 6.98 0 0 0-6.978 6.978v67.842c0 5.298 2.407 10.309 6.542 13.62l29.221 21.685a6.98 6.98 0 0 0 9.81-1.09l8.722-10.904a6.98 6.98 0 0 0-1.086-9.813l-25.296-18.536V77.113a6.98 6.98 0 0 0-6.978-6.978"
})));
export default SvgQtTime;